import React from 'react';
import { Mail, Instagram, Facebook, MessageCircle, ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const SOCIALS = [
  { name: 'Instagram', handle: '@geth.abita', url: 'https://www.instagram.com/geth.abita', Icon: Instagram, color: 'from-pink-500 to-orange-500' },
  { name: 'Facebook', handle: 'habita.co', url: 'https://www.facebook.com/share/1Ehx2532Br/', Icon: Facebook, color: 'from-blue-500 to-blue-700' },
];

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Contacto · habita.co"
        description="¿Tienes preguntas, sugerencias o quieres publicar con nosotros? Escríbenos a contacto@gethabita.co"
      />
      <Header />

      <section className="bg-habita-cream py-20 lg:py-24">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-habita-mint text-habita rounded-full text-xs font-semibold tracking-wide">
            <MessageCircle className="w-3.5 h-3.5" /> ESTAMOS PARA ESCUCHARTE
          </span>
          <h1 className="font-serif text-5xl lg:text-7xl font-bold text-habita-dark mt-5 leading-[1.05]">
            Conversemos.
          </h1>
          <p className="text-gray-700 mt-6 text-lg lg:text-xl max-w-2xl mx-auto leading-relaxed">
            ¿Tienes preguntas, sugerencias o quieres publicar con nosotros?
          </p>
          <p className="text-gray-600 mt-3 text-base max-w-2xl mx-auto leading-relaxed">
            Estamos construyendo una nueva experiencia inmobiliaria en Colombia y nos encantaría escucharte.
          </p>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-4 lg:px-8 py-16">
        {/* EMAIL CARD */}
        <a
          href="mailto:contacto@gethabita.co"
          data-testid="contact-email-btn"
          className="group block bg-white border border-gray-200 hover:border-habita rounded-3xl p-7 lg:p-9 hover-lift transition-all"
        >
          <div className="flex items-center gap-5 flex-wrap">
            <div className="w-14 h-14 rounded-2xl bg-habita-mint flex items-center justify-center shrink-0">
              <Mail className="w-7 h-7 text-habita" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs uppercase tracking-widest text-amber-600 font-semibold">Escríbenos por email</p>
              <p className="font-serif text-2xl lg:text-3xl font-bold text-habita-dark mt-1">contacto@gethabita.co</p>
              <p className="text-sm text-gray-500 mt-1">Respondemos en menos de 24 horas hábiles.</p>
            </div>
            <ArrowRight className="w-5 h-5 text-habita group-hover:translate-x-1 transition-transform shrink-0" />
          </div>
        </a>

        {/* SOCIALS */}
        <div className="mt-10">
          <p className="text-sm text-gray-500 text-center">
            📱 También puedes escribirnos a través de nuestras redes sociales oficiales.
          </p>
          <div className="mt-5 grid sm:grid-cols-2 gap-4" data-testid="contact-socials">
            {SOCIALS.map(({ name, handle, url, Icon, color }) => (
              <a
                key={name}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Síguenos en ${name}`}
                data-testid={`contact-social-${name.toLowerCase()}`}
                className="group relative overflow-hidden bg-white border border-gray-200 hover:border-habita-dark rounded-2xl p-5 transition-all"
              >
                <div className="flex items-center gap-4">
                  <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${color} text-white flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform`}>
                    <Icon className="w-5 h-5" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-habita-dark">{name}</p>
                    <p className="text-sm text-gray-500 truncate">{handle}</p>
                  </div>
                  <ArrowRight className="w-4 h-4 text-gray-400 group-hover:text-habita group-hover:translate-x-1 transition-all shrink-0" />
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* CLOSING */}
        <div className="mt-14 text-center max-w-xl mx-auto">
          <p className="text-gray-500 text-sm italic">
            "Más que una plataforma, queremos construir una marca moderna, cercana y confiable para quienes buscan su próximo hogar."
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
